import React from 'react';
import { Card } from './ui/card';

const Education = () => {
  return (
    <section id="education" className="py-24 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-slate-900 mb-12">Education & Background</h2>

        <div className="grid md:grid-cols-2 gap-8">
          <Card className="p-6 border-slate-200">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">Education</h3>
            <div className="space-y-4">
              <div>
                <div className="font-medium text-slate-900">PGDM in Marketing</div>
                <div className="text-sm text-slate-600">IIM Kozhikode</div>
              </div>
              <div>
                <div className="font-medium text-slate-900">B.Tech in Computer Science</div>
                <div className="text-sm text-slate-600">IP University, Delhi</div>
              </div>
            </div>
          </Card>

          <Card className="p-6 border-slate-200">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">Core Capabilities</h3>
            <div className="space-y-2 text-sm text-slate-700">
              <div>• Marketing strategy and execution leadership</div>
              <div>• AI systems design and implementation</div>
              <div>• Large-scale budget management (₹1000Cr+)</div>
              <div>• Cross-functional team building and leadership</div>
              <div>• Performance marketing and growth systems</div>
              <div>• B2B, B2C, and platform marketing</div>
            </div>
          </Card>
        </div>

        <div className="mt-8 p-6 bg-white border border-slate-200 rounded-lg">
          <p className="text-slate-700 leading-relaxed">
            <strong className="text-slate-900">Background:</strong> 12+ years leading marketing across 
            fintech, education, marketplaces, media, and enterprise platforms. Technical understanding from 
            computer science background. Experience managing budgets from ₹10Cr to ₹1000Cr+. Built and led 
            teams from 5 to 50+ people.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Education;